import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, } from 'react';
import theme from '../../styles/theme';
import { ImagePickerContext } from './ImagePickerContext';
const defaultProps = {
    className: '',
    labelContainerClassname: '',
    multiSelect: false,
    optionsContainerClassname: '',
    textLabelTitle: '',
    textLabelValue: '',
};
const ImagePicker = ({ children, className = defaultProps.className, labelContainerClassname = defaultProps.labelContainerClassname, multiSelect = defaultProps.multiSelect, optionsContainerClassname = defaultProps.optionsContainerClassname, textLabelTitle = defaultProps.textLabelTitle, textLabelValue = defaultProps.textLabelValue, }) => (_jsxs("div", Object.assign({ className: className, role: multiSelect ? undefined : 'radiogroup' }, { children: [(textLabelTitle || textLabelValue) && (_jsxs("div", Object.assign({ className: labelContainerClassname, css: theme.typeStyles.bodyMediumStyles }, { children: [textLabelTitle && (_jsx("span", Object.assign({ css: theme.typeStyles.bodyBoldStyles }, { children: textLabelTitle }))), textLabelValue && (_jsx("span", { children: textLabelValue }))] }))), _jsx("div", Object.assign({ className: optionsContainerClassname }, { children: _jsx(ImagePickerContext.Provider, Object.assign({ value: {
                    multiSelect,
                } }, { children: children })) }))] })));
const MemoizedImagePicker = memo(ImagePicker);
export { MemoizedImagePicker as ImagePicker };
// MC-1068 Temporary hack for Storybook.
export default ImagePicker;
